import { getIn, useFormikContext } from 'formik';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { graphql } from '@e-socna/data-layer';

import { getTouchedError } from '../../../../utils/get-touched-error.util';
import type { ThirdPartyForm_ThirdParty } from '../../fragments/third-party.fragment';

export const ThirdPartyForm_ContactInfoStep_ThirdParty_Fragment = graphql(`
  fragment ThirdPartyForm_ContactInfoStep_ThirdParty_Fragment on ThirdParty {
    contactInfo {
      _id
      email
      faxNumber
      landlineNumber
      mobileNumber
      professionalNumber
      website
    }
  }
`);

interface Props {
  readonly id: string;
}

// eslint-disable-next-line no-empty-pattern
export const ThirdPartyContactInfoFormStep = ({}: Readonly<Props>) => {
  const { errors, handleBlur, handleChange, touched, values } =
    useFormikContext<ThirdPartyForm_ThirdParty>();

  return (
    <Grid container spacing={2} sx={{ alignContent: 'flex-start' }}>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.email') &&
              getIn(touched, 'contactInfo.email')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'contactInfo.email')}
          id="third-party-contact-info-email"
          label="Email"
          name="contactInfo.email"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="contact@exemple.com"
          type="email"
          value={values.contactInfo?.email}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.mobileNumber') &&
              getIn(touched, 'contactInfo.mobileNumber')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'contactInfo.mobileNumber',
          )}
          id="third-party-contact-info-mobile-number"
          label="Numéro téléphone portable"
          name="contactInfo.mobileNumber"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="+33612345678"
          type="tel"
          value={values.contactInfo?.mobileNumber}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.landlineNumber') &&
              getIn(touched, 'contactInfo.landlineNumber')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'contactInfo.landlineNumber',
          )}
          id="third-party-contact-info-landline-number"
          label="Numéro téléphone fixe"
          name="contactInfo.landlineNumber"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="+33123456789"
          type="tel"
          value={values.contactInfo?.landlineNumber}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.professionalNumber') &&
              getIn(touched, 'contactInfo.professionalNumber')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'contactInfo.professionalNumber',
          )}
          id="third-party-contact-info-professional-number"
          label="Numéro téléphone professionnel"
          name="contactInfo.professionalNumber"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="+33123456789"
          type="tel"
          value={values.contactInfo?.professionalNumber}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.faxNumber') &&
              getIn(touched, 'contactInfo.faxNumber')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'contactInfo.faxNumber')}
          id="third-party-contact-info-fax-number"
          label="Numéro fax"
          name="contactInfo.faxNumber"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="+33123456789"
          type="tel"
          value={values.contactInfo?.faxNumber}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'contactInfo.website') &&
              getIn(touched, 'contactInfo.website')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'contactInfo.website')}
          id="third-party-contact-info-website"
          label="Site internet"
          name="contactInfo.website"
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder="https://www.exemple.com"
          type="url"
          value={values.contactInfo?.website}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};
